simpleKeyArgsFn